import { CMSCroppedImage } from 'components/images/Image';
import { FwPakkeImageDocument, ICultureArticle } from 'lib/types/sanity';
import Link from 'next/link';
import styles from "./OneCultureShowWithoutTime.module.css";



//#region [Props]
type OneCultureShowProps = {
    article: ICultureArticle;
    className?: string;
};
//#endregion

//#region [Component]
export default function OneCultureShowWithoutTime({ article, className }: OneCultureShowProps) {
    const url = `/kulturprogram/${article.kulnr.current}`;
    return <article className={className}>
        <Link href={url} passHref legacyBehavior>
            <a className={styles.SImageContainer} >
                {article?.image && <CMSCroppedImage className={styles.SCultureImage} image={article.image as FwPakkeImageDocument} width={470} heightRatio={0.5625} sizes="(min-width: 641px) 470px, 100vw" />}
                {!article?.image && <div className={styles.SImageMissing}></div>}
            </a>
        </Link>
        <div className={styles.STitleContainer}>
            <h1><Link href={url}>{article.titleOverride ?? article.title}</Link></h1>
        </div>
    </article>;
}


//#endregion